module.exports = __webpack_public_path__ + "img/loan.0921fcf7.svg";